import Enum from "../../../enums/Enum";

const EnumInsuranceType = new Enum({
    AUTOMATIC: "Automatically added",
    MANUAL: "Manually added"
});

export default EnumInsuranceType;